import { useRef } from 'react'
import Header from './Header/Header'
import Content from './Content/Content'
import Footer from './Footer/Footer'
import './Landing.css'

function Landing() {
    const newsLetterRef = useRef()
    const heroRef = useRef()
    const headQuartersRef = useRef()
    const privacyRef = useRef()
    return (
        <div >
            <Header newsLetterRef={newsLetterRef} heroRef={heroRef} headQuartersRef={headQuartersRef} privacyRef={privacyRef} />
            <Content newsLetterRef={newsLetterRef} heroRef={heroRef} headQuartersRef={headQuartersRef} privacyRef={privacyRef} />
            <Footer />
        </div>
    );
}

export default Landing
